import { CONCERN_MAX, detectCrisis } from '@tarot/shared';
import { CrisisNotice } from './CrisisNotice';

/**
 * 고민 한 줄 입력 — **선택 사항**.
 * 적으면 해석이 그 고민에 맞춰지고, 비워두면 주제 기준으로만 해석한다.
 * 타로의 흐름상 "질문을 품고 카드를 뽑는" 순서라 카드 뽑기 전에 놓는다.
 */
export function ConcernField({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (v: string) => void;
  disabled?: boolean;
}) {
  /**
   * 위기 신호는 **적는 순간** 안내한다 — 카드를 다 뽑고 해석 버튼을 누른 뒤에야
   * 알려주면 그 사이 시간이 통째로 낭비된다. 판정은 서버와 같은 함수(shared safety.ts)를 쓴다.
   * 입력을 막지는 않는다. 실제로 해석을 되돌리는 건 서버다.
   */
  const crisis = detectCrisis(value);

  return (
    <div className="flex flex-col gap-1.5 rounded-2xl border border-white/10 bg-white/5 p-3">
      <label htmlFor="concern" className="flex items-baseline justify-between gap-2">
        <span className="text-sm font-medium">
          무엇이 궁금하세요? <span className="text-xs font-normal text-moon-dim">(선택)</span>
        </span>
        <span className="shrink-0 text-[11px] tabular-nums text-moon-dim/70">
          {value.length}/{CONCERN_MAX}
        </span>
      </label>
      <textarea
        id="concern"
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, CONCERN_MAX))}
        maxLength={CONCERN_MAX}
        rows={2}
        disabled={disabled}
        placeholder="예) 요즘 자꾸 연락이 뜸해진 사람이 있어요"
        className="resize-none rounded-xl border border-white/15 bg-night-2 px-3 py-2 text-sm leading-relaxed placeholder:text-moon-dim/50 focus:border-gold/60 focus:outline-none disabled:opacity-50"
      />
      {crisis ? (
        <CrisisNotice compact />
      ) : (
        <p className="text-xs text-moon-dim/70">
          고민을 적으면 그 상황에 맞춰 더 구체적으로 읽어드려요
        </p>
      )}
    </div>
  );
}
